import { MigrationSource } from "./migrationSource";

const standardCSVFileMapping = {
  customers: ["customers.csv"],
  customerNotes: ["customer_notes.csv"],
  giftCards: ["gift_cards.csv"],
  items: ["items.csv"],
  inventoryOnHand: ["inventory_oh.csv"],
  locations: ["locations.csv"],
  purchaseOrders: ["purchase_orders.csv"],
  salesHistory: ["sales_history.csv"],
  storeCredits: ["store_credits.csv"],
  vendors: ["vendors.csv"],
};

const migrationSources: MigrationSource = {
  qbpos: {
    name: "QuickBooks POS",
    logo: "/images/logos/qbpos.png",
    requiresAgent: true,
  },
  "liquor-pos": {
    name: "LiquorPOS",
    logo: "/images/logos/liquor_pos.png",
    requiresAgent: true,
  },
  vend: {
    name: "Vend",
    logo: "/images/logos/vend.png",
    options: [
      { name: "Vend Subdomain", key: "sourceSubdomain", type: "string" },
      { name: "Vend API Token", key: "sourceApiToken", type: "string" },
    ],
  },
  csv: {
    name: "CSV",
    logo: "/images/logos/csv.png",
    requiresFileUpload: true,
    requiredRecordFiles: standardCSVFileMapping,
  },
  "sr-api": {
    name: "Heartland Retail",
    logo: "/images/logos/springboard.png",
    options: [
      { name: "Source Subdomain", key: "sourceSubdomain", type: "string" },
    ],
  },
  "pm-plus": {
    name: "PM+",
    logo: "/images/logos/pm_plus.png",
  },
  //   retail_pro_8: {
  //     name: "Retail Pro 8",
  //     logo: "/images/logos/retail_pro.png",
  //     options: []
  //   },
  //   counterpoint_sql: {
  //     name: "CounterPoint SQL",
  //     logo: "/images/logos/counterpoint.png",
  //     options: []
  //   },
  //   retail_star: {
  //     name: "Retail Star",
  //     logo: "/images/logos/retail_star.png",
  //     options: []
  //   },
  //   retail_pro_9: {
  //     name: "Retail Pro 9",
  //     logo: "/images/logos/retail_pro.png",
  //     options: []
  //   },
  //   rics: {
  //     name: "Rics",
  //     logo: "/images/logos/rics.png",
  //     options: []
  //   },
  //   lightspeed_cloud: {
  //     name: "Lightspeed Cloud",
  //     logo: "/images/logos/lightspeed.png",
  //     options: []
  //   },
  //   lightspeed_desktop: {
  //     name: "Lightspeed Desktop",
  //     logo: "/images/logos/lightspeed_desktop.png",
  //     options: []
  //   },
  //   counterpoint_7: {
  //     name: "CounterPoint 7",
  //     logo: "/images/logos/counterpoint_7.png",
  //     options: []
  //   },
  //   runit: {
  //     name: "RunIt",
  //     logo: "/images/logos/runit.png",
  //     options: []
  //   },
  //   charter_rmsa: {
  //     name: "Charter RMSA",
  //     logo: "/images/logos/charter_rmsa.png",
  //     options: []
  //   },
  //   retail_edge: {
  //     name: "Retail Edge",
  //     logo: "/images/logos/retail_edge.png",
  //     options: []
  //   }
};

export default migrationSources;
